import { render } from "./RomanReferences.vue?vue&type=template&id=b6198980"
import script from "./RomanReferences.vue?vue&type=script&lang=js"
export * from "./RomanReferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__